import { mapState } from 'vuex';
import mixinActionBoxStyles from './mixinActionBoxStyles';
export default {
  name: 'CoreHeader',
  mixins: [mixinActionBoxStyles],
  props: {
    headerBG: {
      type: String,
      required: false,
      default: null
    },
    headline: {
      type: String,
      default: '',
      required: false
    },
    subtitle: {
      type: String,
      required: false,
      default: () => null
    },
    loader: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: false
    },
    formIsValid: {
      type: Boolean,
      required: false,
      default: false
    },
    cancelButton: {
      type: Boolean,
      required: false,
      default: false
    },
    saveButton: {
      type: Boolean,
      required: false,
      default: false
    },
    buttons: {
      type: Array,
      required: false,
      default: () => null
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    isProductiveVersion: {
      type: Boolean,
      required: false,
      default: false
    },
    hasUnsyncedChanges: {
      type: Boolean,
      required: false,
      default: false
    },
    itemIsChanged: {
      type: Boolean,
      required: false,
      default: false
    },
    showBetaBadge: {
      type: [Boolean, String],
      required: false,
      default: () => false
    }
  },
  data: function () {
    return {
      pageYOffset: 0,
      validStates: []
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    styles() {
      let width = 0;
      if (!this.saveButton && !this.cancelButton) {
        let width = 10;
        return {
          width: 'fit-content',
          'max-width': `calc(100% - ${width}px)`
        };
      }
      if (this.saveButton) {
        width = width + 165;
      }
      if (this.cancelButton) {
        width = width + 65;
      }
      return {
        'max-width': `calc(100% - ${width}px)`,
        width: 'fit-content'
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    cloading() {
      return this.$store.state.app.loading;
    },
    displayButtons() {
      if (this.buttons) {
        return this.buttons;
      }
      let buttons = [];
      if (this.saveButton) {
        buttons.push({
          icon: 'fas fa-save',
          title: this.$i18n_t('Common.save'),
          disabled: this.templateContext && this.isProductiveVersion,
          type: 'submit',
          action: 'saveData'
        });
      }
      if (this.cancelButton) {
        buttons.push({
          icon: 'fal fa-times',
          color: 'danger',
          disabled: this.templateContext && this.isProductiveVersion,
          action: 'cancel',
          tooltip: this.$i18n_t('Common.cancel')
        });
      }
      return buttons.length ? buttons : null;
    }
  },
  watch: {
    displayButtons: {
      handler(newV) {
        this.validStates = (newV || []).map(button => button.valid === undefined || button.valid);
      },
      deep: true
    }
  },
  mounted() {
    this.validStates = (this.displayButtons || []).map(button => button.valid === undefined || button.valid);
    window.addEventListener('scroll', this.saveScrollOffset);
    this.actionBoxIsFixed = !this.headerBG && !this.headline && this.subtitle && !this.$slots['headline'];
  },
  destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: {
    buttonHasValidState(i) {
      if (i < this.validStates.length) {
        return this.validStates[i];
      }
      return true;
    },
    saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    handleButtonClick(buttonDefinition) {
      if (!buttonDefinition) {
        return;
      }
      if (buttonDefinition.action) {
        this.$emit(buttonDefinition.action);
      }
      if (buttonDefinition.onClick) {
        buttonDefinition.onClick();
      }
    }
  }
};